import { FileUpload, FileUploadProps } from '@makyoapp/makyo-tw-ui'

export type CompFileUploadProps = FileUploadProps

/**
 * CompFileUploadCore
 */
export const CompFileUploadCore = FileUpload
